import { useState, useEffect } from 'react';
import { Typography, Button } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types';
import styles from './WalletDeficitBox.module.css';
import { RedeemtoWalletApi } from 'utils/API/Merchant APIs/WalletApiCalls';
import { globalNotifySuccess } from 'views/utilities/AlertToast';
import { fetchWalletBalanceAsync } from 'redux/WalletSlice';

const WalletDeficitBox = ({ visible, deficitAmount, balanceW1, tamount, onTransfer, onCancel }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const agent = localStorage.getItem('id');

    const handleTransfer = async (amount) => {
        setLoading(true);
        const payload = { agent, amount, isDeficit: true };
        const response = await RedeemtoWalletApi(payload);
        setLoading(false);

        if (response?.status === 200) {
            dispatch(fetchWalletBalanceAsync());
            setIsSuccess(true);
            globalNotifySuccess(`Successfully transferred ₹${amount} from Wallet 2 to Wallet 1`);
            setTimeout(() => {
                onCancel(); // Hide the box after success
                setIsSuccess(false);
            }, 2000);
        }
    };

    // Auto-hide after success
    useEffect(() => {
        if (isSuccess) {
            const timer = setTimeout(() => {
                onTransfer(); // Notify parent and hide box
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [isSuccess, onTransfer]);

    if (!visible) return null;

    return (
        <AnimatePresence>
            <motion.div
                className={styles.boxWrapper}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4, type: 'spring' }}
            >
                {!isSuccess ? (
                    <>
                        <Typography variant="h6" className={styles.heading}>
                            Insufficient Wallet-1 Balance
                        </Typography>

                        <Typography variant="body1" className={styles.info}>
                            Wallet 1 has <strong>₹ {balanceW1}</strong>
                            <br /> you're trying to transfer <strong>₹ {tamount} </strong>
                            (including charges).
                        </Typography>

                        <Typography variant="body1" className={styles.info}>
                            You can transfer <strong>₹ {deficitAmount}</strong> from Wallet 2 to Wallet 1 to proceed.
                        </Typography>

                        <div className={styles.buttonGroup}>
                            <LoadingButton
                                loading={loading}
                                variant="contained"
                                color="primary"
                                onClick={() => handleTransfer(deficitAmount)}
                                className={styles.transferButton}
                            >
                                Transfer ₹ {deficitAmount} from Wallet 2 to Wallet 1
                            </LoadingButton>
                            <Button variant="outlined" onClick={onCancel}>
                                Cancel
                            </Button>
                        </div>
                    </>
                ) : (
                    <motion.div
                        className={styles.successContainer}
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.5, type: 'spring' }}
                    >
                        <CheckCircleIcon className={styles.successIcon} />
                        <Typography variant="h6" className={styles.successMessage}>
                            Wallet loaded, You can now proceed with your transaction.
                        </Typography>
                    </motion.div>
                )}
            </motion.div>
        </AnimatePresence>
    );
};

export default WalletDeficitBox;
WalletDeficitBox.propTypes = {
    visible: PropTypes.bool,
    deficitAmount: PropTypes.number,
    balanceW1: PropTypes.number,
    tamount: PropTypes.number,
    onTransfer: PropTypes.func,
    onCancel: PropTypes.func
};
